import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { LineStatus } from '../../../../redux/tickets/types/kds-line/status';
import { getActualRoute } from '../../../../redux/router/selector';
import { Routes } from '../../../../routes.types';

const TEMPORARY_ICON_DURATION_MS = 2000;

export const useTemporaryNextIconVM = (status: LineStatus) => {
    const route = useSelector(getActualRoute);
    const [showTemporaryNextIcon, setShowTemporaryNextIcon] = useState(false);

    const isDeliveredOnHome = status === LineStatus.Delivered && route === Routes.Home;

    useEffect(() => {
        if (!showTemporaryNextIcon) return;
        const timer = setTimeout(() => setShowTemporaryNextIcon(false), TEMPORARY_ICON_DURATION_MS);
        return () => clearTimeout(timer);
    }, [showTemporaryNextIcon]);

    const triggerTemporaryNextIcon = useCallback(() => {
        if (isDeliveredOnHome) {
            setShowTemporaryNextIcon(true);
        }
    }, [isDeliveredOnHome]);

    return { showTemporaryNextIcon, triggerTemporaryNextIcon };
};
